<template>
  <div v-if="$store.getters['event/isLoaded']" class="ecran-geant">
    <EcranHeader
      ref="ecranHeader"
      :nomEpreuve="nomEpreuve"
      :titleResults="hasParcours ? titleResults : 'Aucun parcours disponible'"
      :indicator="parcoursIndicator"
    />

    <div class="ecran-geant__content" :style="{ paddingTop: headerHeight + 'px' }">
      <div class="content-container ecran-geant__tableau">
        <FullScreenLoading v-if="loading || scrollLoading" action="Chargement en cours"></FullScreenLoading>
        <template v-else-if="hasParcours">
          <TableauResultats id="tableau-resultats" v-if="$store.getters['event/showDefaultResults']">
          </TableauResultats>
          <TableauResultatsPassages v-else-if="$store.getters['event/showPassagesResults']">
          </TableauResultatsPassages>
          <TableauResultatsEquipe id="tableau-resultats" v-else-if="$store.getters['event/showTeamResults']">
          </TableauResultatsEquipe>
          <AttenteResultats v-if="!$store.getters['event/has_results']"></AttenteResultats>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import EcranHeader from "@/component/Epreuve/EcranHeader";
import TableauResultats from "@/component/Epreuve/TableauResultats";
import TableauResultatsPassages from "@/component/Epreuve/TableauResultatsPassages";
import TableauResultatsEquipe from "@/component/Epreuve/TableauResultatsEquipe";
import FullScreenLoading from "@/component/FullScreenLoading";
import AttenteResultats from "@/component/Epreuve/AttenteResultats";
import autoScrollParcours from "@/mixins/autoScrollParcours";

export default {
  components: {
    EcranHeader,
    TableauResultats,
    TableauResultatsPassages,
    TableauResultatsEquipe,
    FullScreenLoading,
    AttenteResultats,
  },

  mixins: [autoScrollParcours],

  data() {
    return {
      loading: true,
      headerHeight: 56,
    };
  },

  computed: {
    nomEpreuve() {
      return this.$store.state.event.data.nom_epreuve;
    },
    titleResults() {
      return this.$store.getters["event/titleResults"];
    },
  },

  methods: {
    async initView() {
      this.loading = true;
      const query = this.$route.query;
      this.$store.dispatch("event/init", query);
      await this.$store.dispatch("event/fetch");
      this.loading = false;
    },

    updateHeaderHeight() {
      this.headerHeight = this.getHeaderHeight() || 56;
    },
  },

  async mounted() {
    await this.initView();
    await this.$nextTick();
    this.updateHeaderHeight();
    window.addEventListener("resize", this.updateHeaderHeight);
    this.startAutoScroll();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateHeaderHeight);
  },
};
</script>

<style scoped>
.ecran-geant__content {
  min-height: 100vh;
}

.ecran-geant__tableau >>> .table-striped tbody {
  cursor: default;
  pointer-events: none;
}

.ecran-geant__tableau >>> .btn-informations,
.ecran-geant__tableau >>> .diploma-dl-btn {
  display: none;
}
</style>
